import { api } from "../api/client";

// Requests started before the page that needs them has loaded. Pages are
// code-split, so without this a page's data only starts downloading once its
// chunk has; `useApi` picks a prefetched request up instead of sending its own.
const pending = new Map<string, { at: number; request: Promise<unknown> }>();

// Older than this, a prefetch is ignored: something may have changed since.
const FRESH_MS = 10_000;

export const prefetch = (path: string): void => {
  // A first load, so the device's copy will do (src/api/useApi.ts).
  const request = api.get(path, true, true);
  // The page reports failures when it takes the request; one it never takes
  // mustn't surface as an unhandled rejection.
  request.catch(() => {});
  pending.set(path, { at: Date.now(), request });
};

// Hand over (once) a fresh prefetched request for `path`, if there is one.
export const takePrefetched = <T>(path: string): Promise<T> | undefined => {
  const found = pending.get(path);
  pending.delete(path);
  if (!found || Date.now() - found.at > FRESH_MS) return undefined;
  return found.request as Promise<T>;
};
